module.exports = __webpack_public_path__ + "img/logo.53d0fc9f.png";